import { queueService } from '@/services';

export const queueModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
    queue:{
      data: null,
      error: null,
    },
    requeue:
    {
      data: null,
      status: null,
    },
  }),
  mutations: {
    load(state,request) {
      queueService.getQueues(request.pagination,request.filters)
        .then((res) => {
          state.list.data = res
        })
        .catch((error) => {
          state.list.data = null
          state.list.error = error
        });      
    },
    getById(state, request) {
      queueService.getQueuetById(request.id, request.entity)
        .then((res) => {
          state.queue.data = res
        })
        .catch((error) => {
          state.queue.data = null
          state.queue.error = error
        });      
    },
    requeue(state, filters){
      queueService.requeue(filters)
      .then((res) => {
        state.requeue.data = { ...res }
        state.requeue.status = {
          requeued: true,
        }
      })
      .catch((error) => {
        state.requeue.data = null
        state.requeue.status = {
          ...error
        }
      }); 
    },
  }
}